<div class="flex flex-row">
  <input
    type="file"
    class="file-input hidden"
    (change)="onFileSelected($event)"
    accept=".pdf,.doc,.docx"
    #fileUpload
  />
  <div
    class="p-4 bg-primary w-100 cursor-pointer text-center rounded-lg"
    (click)="fileUpload.click()"
  >
    <span class="mr-5 text-white">{{ "FILE_UPLOAD.FILE_UPLOAD" | translate }}</span>
    <i class="fa-solid fa-file" style="color: white"></i>
  </div>
</div>
@if(filesToUpload().length>0){
<div class="file-list mt-3">
  <h6>{{ "FILE_UPLOAD.PENDING_FILES" | translate }}</h6>
  @for (file of filesToUpload(); track $index; let index = $index) {
  <div class="file-item">
    <div
      class="flex justify-between items-center bg-black p-4 rounded-l-lg rounded-r-4xl mb-3"
    >
      <span class="text-white text-truncate">{{ file.name }}</span>
      <div class="ml-4 flex items-center">
        <span
          class="ml-2 text-white cursor-pointer"
          (click)="removePendingFile(file)"
          >x</span
        >
      </div>
    </div>
  </div>
  }
  <button
    pButton
    severity="success"
    class="w-100"
    (click)="uploadFilesHandler()"
  >
    {{ "FILE_UPLOAD.UPLOAD_FILES" | translate }}
  </button>
</div>
}
<!--  -->
@if(selectedFiles()!==undefined && selectedFiles()!.length>0){
<div class="file-list mt-3">
  <h6>{{ "FILE_UPLOAD.UPLOADED_FILES" | translate }}</h6>
  @for (file of selectedFiles(); track $index; let index = $index) {
  <div class="file-item">
    <div
      class="flex justify-between items-center bg-black p-4 rounded-l-lg rounded-r-4xl mb-3"
    >
      <span class="text-white text-truncate">{{ file.fileName }}</span>
      <div class="ml-4 flex items-center">
        <div class="text-white"></div>
        <span
          class="ml-2 text-white cursor-pointer"
          (click)="removePendingFile(file)"
          >x</span
        >
      </div>
    </div>
  </div>
  }
</div>
}
